<template>
  <div>
    <el-form-item label="提示文字">
      <!-- {{ value }} -->
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语" maxlength="50" show-word-limit/>
    </el-form-item>
    <el-form-item label="单位">
      <el-input size="small" v-model="value.unit" placeholder="请输入"  maxlength="12" show-word-limit/>
    </el-form-item>
    <el-form-item label="小数位数">
      <!-- <el-input size="small" v-model="value.precision" placeholder="请输入"/> -->
      <el-input-number controls-position="right" :precision="0" :max="3" :min="0" size="small" v-model="value.precision"  placeholder="小数位数"/>
    </el-form-item>
    <!-- <el-form-item label="保留小数">
      <el-input-number controls-position="right" :precision="0" :max="3" :min="0" size="small" v-model="value.precision"  placeholder="小数位数"/>
       位
    </el-form-item> -->
  </div>
</template>

<script>
export default {
  name: "NumberInput",
  components: {},
  props:{
    value:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
/deep/.el-input-number--small{
  width: 100%;
}
</style>
